<template>
  <md-dialog
    :md-active.sync="isShowDialog"
    class="new w-800"
    :md-fullscreen="false"
    @md-opened="scroll('locked')"
    @md-closed="scroll('clear')"
  >
    <md-dialog-title>お気に入りの場所編集</md-dialog-title>
    <div class="p-2 of-auto">
      <direct-edit
        :_search-cond="searchCond"
        :is-search="isSearch"
        :is-valid="isValid"
        :is-meihen="isMeihen"
        @setInvalid="onSetInvalid"
        @setData="onSetData"
        @searched="onSearched"
      />
    </div>
    <md-dialog-actions>
      <md-button class="md-primary" @click="isShowDialog = false">
        閉じる
      </md-button>
      <md-button class="md-primary" @click="valid">登録</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import Mixin from '../mixin/Mixin'
import _ from 'lodash'
import Store from '@/store/index.js'
import DirectEdit from '@/components/order/DirectEdit'

const DATA_KBN_AA = 'AUCTION'
const DATA_KBN_DIRECT = 'DIRECT'
export default {
  name: 'DirectEditDialog',

  components: {
    DirectEdit,
  },

  mixins: [Mixin],

  props: {
    /** Dialog表示フラグ */
    isShow: {
      type: Boolean,
      default: false,
    },

    /** 編集元データ */
    _editedItem: {
      type: Object,
      default: null,
    },

    /** 名変フラグ */
    isMeihen: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    /** 編集データ */
    editedItem: null,

    /** 検索実行フラグ */
    isSearch: false,

    /** バリデーション実行フラグ */
    isValid: false,

    /** Dialog表示フラグ */
    isShowDialog: false,

    /** 検索条件 */
    searchCond: {},
  }),

  methods: {
    async valid() {
      this.spinerOff()
      this.isValid = true
    },

    /** 保存する */
    save() {
      const data = this.makeSavedItem()
      Store.dispatch('order/updateOkiniiri', data)
        .then((res) => {
          this.$emit('saved')
          this.isShowDialog = false
        })
        .catch((err) => {
          this._alert('エラーが発生しました code: 504', false)
        })
    },

    /** 保存用データを生成する */
    makeSavedItem() {
      return {
        OKINIIRI_ID: this._editedItem ? this._editedItem.FAVORITE_ID : null,
        HIKINO_AA_CD: this.editedItem.AA_ID,
        HIKINO_AA_SHIKI_CD: this.editedItem.AA_CD,
        HIKINO_YUBIN1: this.editedItem.YUBIN1,
        HIKINO_YUBIN2: this.editedItem.YUBIN2,
        HIKINO_TODO_CD: this.editedItem.TODO_CD,
        HIKINO_TODO_MEI: this.editedItem.TODO_MEI,
        HIKINO_SHIKU_CD: this.editedItem.SHIKU_CD,
        HIKINO_SHIKU_MEI: this.editedItem.SHIKU_MEI,
        HIKINO_BANCHI: this.editedItem.BANCHI,
        HIKINO_MEI: this.editedItem.MEI,
        HIKINO_TEL: this.editedItem.TEL,
        HIKINO_YUSO_KBN: this.editedItem.YUSO_KBN,
        HIKINO_HCB_ZOKUSEI_CD: this.editedItem.HCB_ZOKUSEI_CD,
        HIKINO_LANDMARK_KBN: this.editedItem.LANDMARK_KBN,
        HIKINO_TANTO_MEI: this.editedItem.TANTO_MEI,
        HIKINO_TANTO_TEL: this.editedItem.TANTO_TEL,
        HIKINO_TEIKYU_BI: this.editedItem.TEIKYU_BI
          ? this.editedItem.TEIKYU_BI.join(',')
          : null,
        HIKINO_EIGYO_KAISI_JIKAN: this.editedItem.EIGYO_KAISI_JIKAN,
        HIKINO_EIGYO_SYURYO_JIKAN: this.editedItem.EIGYO_SYURYO_JIKAN,
      }
    },

    /** 編集 */
    makeEditItem(val) {
      if (val.TEIKYU_BI) val.TEIKYU_BI = val.TEIKYU_BI.split(',')
      this.searchCond.isAAFlg = val.AA_CD ? true : false
      if (val.AA_CD)
        this.searchCond.aa = {
          AA_ID: val.AA_ID,
          AA_CD: val.AA_CD,
          TODO_CD: val.TODO_CD,
        }
      else this.searchCond.other = val
      this.search()
    },

    /** 検索(Dialog表示) */
    async search() {
      this.isShowDialog = true
      await this.sleep(100)
      this.isSearch = true
    },

    /** バリデーション結果通知 */
    async onSetInvalid(val) {
      this.isValid = false
      if (!val) this.save()
    },

    /** 入力データ通知 */
    onSetData(val) {
      this.editedItem = val
    },

    /** 検索完了通知 */
    onSearched() {
      this.isSearch = false
    },
  },

  watch: {
    /** モーダル表示フラグ監視 */
    isShow(val) {
      if (val) {
        if (this._editedItem) this.makeEditItem(this._editedItem)
        else {
          this.searchCond = {}
          this.search()
        }
        this.$emit('showed')
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.md-checkbox
  margin: 0
</style>



// WEBPACK FOOTER //
// src/components/order/DirectEditDialog.vue